
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import React, { useEffect } from 'react';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link,useNavigate } from "react-router-dom";
import PureCounter from "@srexi/purecounterjs";

const Technologies = () => {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll)
    AOS.init();

    // Initialize Swiper
    const swiper = new Swiper('.review-swiper', {
      spaceBetween: 15,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 3 },
        480: { slidesPerView: 1 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },
    });

    // Initialize PureCounter
    new PureCounter({
      selector: '.purecounter',
      start: 0,
      end: 500,
      duration: 1,
      delay: 10,
      once: true,
      pulse: false,
      decimals: 0,
      legacy: true,
      filesizing: false,
      currency: false,
      formater: 'us-US',
      separator: false,
    });

    // Handle Scroll Event for Navbar Shadow
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (window.scrollY > 50) {
        navbar.classList.add('shadow');
      } else {
        navbar.classList.remove('shadow');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      swiper.destroy();
    };
  }, []);

  return (
    <div>
   <Navbar/>


  {/* <section id="tech-web-tech" className="tech-tech-section">
    <h2 className="tech-section-title">Web Technologies</h2>
    <div className="tech-tech-cards">
    <div className="tech-tech-card">
  <img src="/icon/html.png" alt="HTML5"/>
  <h3>HTML5</h3>
  <p>The standard markup language for creating web pages.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/css.png" alt="CSS3"/>
  <h3>CSS3</h3>
  <p>The language used for describing the presentation of a document written in HTML.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/javascript.png" alt="JavaScript"/>
  <h3>JavaScript</h3>
  <p>A high-level programming language used to create dynamic and interactive web content.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/react.png" alt="React"/>
  <h3>React</h3>
  <p>A JavaScript library for building user interfaces, particularly single-page applications.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/angular.png" alt="Angular"/>
  <h3>Angular</h3>
  <p>A platform and framework for building single-page client applications using HTML and TypeScript.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/vue.png" alt="Vue.js"/>
  <h3>Vue.js</h3>
  <p>A progressive JavaScript framework used to build user interfaces and single-page applications.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/node.png" alt="Node.js"/>
  <h3>Node.js</h3>
  <p>A JavaScript runtime environment that allows you to run JavaScript server-side.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/express.png" alt="Express.js"/>
  <h3>Express.js</h3>
  <p>A minimal and flexible Node.js web application framework designed to simplify server-side development.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/bootstrap.png" alt="Bootstrap"/>
  <h3>Bootstrap</h3>
  <p>A front-end framework for developing responsive, mobile-first web pages.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/sass.png" alt="Sass"/>
  <h3>Sass</h3>
  <p>A preprocessor scripting language that is interpreted or compiled into CSS.</p>
</div>

{/* <div className="tech-tech-card">
  <img src="/icon/jquery.png" alt="jQuery"/>
  <h3>jQuery</h3>
  <p>A fast, small, and feature-rich JavaScript library that simplifies things like event handling and AJAX requests.</p>
</div> */}

{/* <div className="tech-tech-card">
  <img src="/icon/laravel.png" alt="Laravel"/>
  <h3>Laravel</h3>
  <p>A PHP web framework that provides an elegant syntax and tools for building modern web applications.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/django.png" alt="Django"/>
  <h3>Django</h3>
  <p>A high-level Python web framework that encourages rapid development and clean, pragmatic design.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/ruby.png" alt="Ruby on Rails"/>
  <h3>Ruby on Rails</h3>
  <p>A full-stack web application framework written in Ruby, known for its convention-over-configuration approach.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/typescript.png" alt="TypeScript"/>
  <h3>TypeScript</h3>
  <p>A superset of JavaScript that adds optional static typing and other features for better tooling and scalability.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/graphql.png" alt="GraphQL"/>
  <h3>GraphQL</h3>
  <p>A query language for APIs and a runtime for executing those queries by using a type system you define for your data.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/webpack.png" alt="Webpack"/>
  <h3>Webpack</h3>
  <p>A module bundler that bundles JavaScript files and other resources like CSS, HTML, and images for web projects.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/docker.png" alt="Docker"/>
  <h3>Docker</h3>
  <p>A platform that enables developers to build, ship, and run applications in isolated environments called containers.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/mongodb.png" alt="MongoDB"/>
  <h3>MongoDB</h3>
  <p>A NoSQL database that stores data in flexible, JSON-like documents, making it easy to scale and develop modern applications.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/mysql.png" alt="MySQL"/>
  <h3>MySQL</h3>
  <p>An open-source relational database management system that uses SQL (Structured Query Language) to manage data.</p>
</div>

<div className="tech-tech-card">
  <img src="/icon/postgresql.png" alt="PostgreSQL"/>
  <h3>PostgreSQL</h3>
  <p>An open-source relational database management system known for its robustness, scalability, and SQL compliance.</p>
</div>

    </div>
  </section> */}
{/* 
  <section id="tech-mobile-tech" className="tech-tech-section">
    <h2 className="tech-section-title">Mobile Technologies</h2>
    <div className="tech-tech-cards">
      <div className="tech-tech-card">
        <img src="/icon/android.png" alt="Android"/>
        <h3>Android</h3>
        <p>The mobile operating system for Android devices.</p>
      </div>
      <div className="tech-tech-card">
        <img src="/icon/ios.png" alt="iOS"/>
        <h3>iOS</h3>
        <p>The mobile operating system for Apple devices.</p>
      </div>
      <div className="tech-tech-card">
        <img src="/icon/flutter.png" alt="Flutter"/>
        <h3>Flutter</h3>
        <p>A UI toolkit for building natively compiled apps for mobile from a single codebase.</p>
      </div>
      <div className="tech-tech-card">
        <img src="/icon/react.png" alt="React Native"/>
        <h3>React Native</h3>
        <p>A framework for building native apps using React.</p>
      </div>
    </div>
  </section> */}
 


 <section class="container-fluid position-relative half-fluid cloudmins-container">
            
              <div class="techContainer">
                <div class="row">
                  <header >
                    <h3 class="section-header">Our TechStack</h3>    
                  </header>
                </div>
                <div class="row">
                  {/* <!-- Text --> */}
                  <div class="col-lg-6 py-5 pe-lg-5 techStackContainer">
                    <h1>We are largely a full stack house</h1>   
                    <div id="marqueeTech">
                      <div class="marquee_group_tech">
                        <div class="imagetechSlider d-flex justify-content-between w-100">
                          <img class="d-block" src="/images/android.svg" alt="First slide"/>                
                          <img class="d-block" src="/images/flutter.svg" alt="Second slide"/>
                          <img class="d-block" src="/images/laravel.svg" alt="Third slide"/>
                          <img class="d-block" src="/images/node.png" alt="Third slide"/>
                          <img class="d-block " src="/images/javascript.svg" alt="Third slide"/>
                          
                        </div>
                        <div class="imagetechSlider d-flex justify-content-between w-100">
                          <img class="d-block " src="/images/typescript.svg" alt="Third slide"/>
                          <img class="d-block " src="/images/postgress.png" alt="Third slide"/>
                          <img class="d-block " src="/images/vue.png" alt="Third slide"/>
                          <img class="d-block " src="/images/mysql.svg" alt="First slide"/>
                          <img class="d-block " src="/images/tailwind.svg" alt="Second slide"/> 
                        </div>
                       
                        <div class="imagetechSlider d-flex justify-content-between w-100">
                          <img class="d-block " src="/images/scss.svg" alt="Third slide"/>
                          <img class="d-block " src="/images/react.webp" alt="Third slide"/>
                          <img class="d-block " src="/images/python.jpg" alt="Third slide"/>
                          <img class="d-block " src="/images/nextjs.svg" alt="Third slide"/>
                          <img class="d-block " src="/images/mongodb.svg" alt="Third slide"/>
                        </div>
                       
                      </div>   
                      <div class="marquee_group_tech" aria-hidden="true">
                          <div class="imagetechSlider d-flex justify-content-between w-100">
                            <img class="d-block" src="/images/android.svg" alt="First slide"/>                
                            <img class="d-block" src="/images/flutter.svg" alt="Second slide"/>
                            <img class="d-block" src="/images/laravel.svg" alt="Third slide"/>
                            <img class="d-block" src="/images/node.png" alt="Third slide"/>
                            <img class="d-block " src="/images/javascript.svg" alt="Third slide"/>
                            
                          </div>
                          <div class="imagetechSlider d-flex justify-content-between w-100">
                            <img class="d-block " src="/images/typescript.svg" alt="Third slide"/>
                            <img class="d-block " src="/images/postgress.png" alt="Third slide"/>
                            <img class="d-block " src="/images/vue.png" alt="Third slide"/>
                            <img class="d-block " src="/images/mysql.svg" alt="First slide"/>
                            <img class="d-block " src="/images/tailwind.svg" alt="Second slide"/> 
                          </div>
                         
                          <div class="imagetechSlider d-flex justify-content-between w-100">
                            <img class="d-block " src="/images/scss.svg" alt="Third slide"/>
                            <img class="d-block " src="/images/react.webp" alt="Third slide"/>
                            <img class="d-block " src="/images/python.jpg" alt="Third slide"/>
                            <img class="d-block " src="/images/nextjs.svg" alt="Third slide"/>
                            <img class="d-block " src="/images/mongodb.svg" alt="Third slide"/>
                          </div>
                         
                        </div>    
                      </div>             
                    </div>             
                  
                  
                  {/* <!-- Image --> */}
                  <div class="col-lg-6 position-lg-absolute right-half h-100 techStackImg">
                    <div class="image"><img src="/images/techStack.webp"/></div>
                  </div>
                </div>
              </div> 
              <div class="approachContainer">
                <div class="row approachRow">
                  <header >
                    <h3 class="section-header">Our Approach</h3>    
                  </header>
                  <div class="col-md-4 d-flex align-items-start mb-4 approachContent">
                      <div class="icon-box pe-4">
                          <i class="fas fa-clipboard-list icon"></i>
                      </div>
                      <div class="approachSteps">
                          <h5>Requirements Analysis</h5>
                          <p><strong>Purpose:</strong> Create an overview of the project, determine requirements, and set the groundwork.</p>
                          <p><strong>Key personnel:</strong> Business analysts.</p>
                          <p><strong>Output:</strong> An SRS document defining goals and needs.</p>
                      </div>
                  </div>
          
                  {/* <!-- Phase 2 --> */}
                  <div class="col-md-4 d-flex align-items-start mb-4 approachContent">
                      <div class="icon-box pe-4">
                          <i class="fas fa-palette icon"></i>
                      </div>
                      <div class="approachSteps">
                          <h5>Design</h5>
                          <p><strong>Purpose:</strong> Design UI, security, and features.</p>
                          <p><strong>Key personnel:</strong> Architects, UI/UX Designers.</p>
                          <p><strong>Output:</strong> A detailed DDS document.</p>
                      </div>
                  </div>
          
                  {/* <!-- Phase 3 --> */}
                  <div class="col-md-4 d-flex align-items-start mb-4 approachContent">
                      <div class="icon-box pe-4">
                          <i class="fas fa-file-code icon"></i>
                      </div>
                      <div class="approachSteps">
                          <h5>Software Development</h5>
                          <p><strong>Purpose:</strong> Translate design into code.</p>
                          <p><strong>Key personnel:</strong> Developers, Project Managers.</p>
                          <p><strong>Output:</strong> Testable software.</p>
                      </div>
                  </div>
          
                  {/* <!-- Phase 4 --> */}
                  <div class="col-md-4 d-flex align-items-start mb-4 approachContent">
                      <div class="icon-box pe-4">
                          <i class="fas fa-calendar-check icon"></i>
                      </div>
                      <div class="approachSteps">
                          <h5>Software Testing</h5>
                          <p><strong>Purpose:</strong> Ensure the product is bug-free.</p>
                          <p><strong>Key personnel:</strong> Testers.</p>
                          <p><strong>Output:</strong> A thoroughly tested product.</p>
                      </div>
                  </div>
          
                  {/* <!-- Phase 5 --> */}
                  <div class="col-md-4 d-flex align-items-start mb-4 approachContent">
                      <div class="icon-box pe-4">
                          <i class="fas fa-cloud-upload-alt icon"></i>
                      </div>
                      <div class="approachSteps">
                          <h5>Deployment</h5>
                          <p><strong>Purpose:</strong> Push product into production.</p>
                          <p><strong>Key personnel:</strong> Deployment engineers.</p>
                          <p><strong>Output:</strong> A fully functional release.</p>
                      </div>
                  </div>
          
                  {/* <!-- Phase 6 --> */}
                  <div class="col-md-4 d-flex align-items-start mb-4 approachContent">
                      <div class="icon-box pe-4">
                          <i class="fas fa-headset icon"></i>
                      </div>
                      <div class="approachSteps">
                          <h5>Support & Maintenance</h5>
                          <p><strong>Purpose:</strong> Optimize performance & security.</p>
                          <p><strong>Key personnel:</strong> Engineers, testers.</p>
                          <p><strong>Output:</strong> A continuously improving product.</p>
                      </div>
                  </div>
                </div>
              </div>                        
            
          </section>

          <br/>
          <br/>
  <Footer/>
    </div>
  )
}

export default Technologies
